import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import "./FeedEventItem.scss";

export const FeedEventItem = (props: any) => {
  const navigate = useNavigate();
  const { item } = props;
  const { me } = useSelector((state: any) => state.auth);

  const goToEvent = () => {
    navigate("/my-campus/event/timeline/" + item.eventContentItem.eventId);
  };

  const isBelongToUser = (e: any) => {
    return me?.events?.includes(e?._id);
  };

  return item && item.eventContentItem && item.eventContentItem.event ? (
    <div
      onClick={() => goToEvent()}
      className="feed-event-item d-flex flex-column"
      style={{
        backgroundImage: `url(${item.eventContentItem.event.thumbnail})`,
      }}
    >
      <div className={item.eventContentItem.event.thumbnail ? "darken" : "bluish"}></div>
      <div className="lighten">
        <div className="py-3 px-3 px-md-4 w-100 d-flex">
          <div className="title">{item.eventContentItem.event.eventTitle}</div>
        </div>
        <div className="py-0 py-md-3 px-3 px-md-4 w-100 d-flex">
          <div className="sep w-75"></div>
        </div>

        <div className="py-3 px-3 px-md-4 w-100 d-flex">
          <div className="e-detail">
            <div className="pre">When</div>
            <div className="val">{moment(item.eventContentItem.event.dtStartDate).format("MMM D, YYYY")}</div>
          </div>
          <div className="e-detail">
            <div className="pre">Time</div>
            <div className="val">{item.eventContentItem.event.time ? item.eventContentItem.event.time : "00:00"}</div>
          </div>
          {item.eventContentItem.event.address ? (
            <div className="e-detail">
              <div className="pre">Where</div>
              <div className="val">{item.eventContentItem.event.address.street}</div>
            </div>
          ) : null}
        </div>

        <div className="py-0 px-3 px-md-4 w-100 d-flex">
          <div className="">
            <button className="seat">
              {!isBelongToUser(item.eventContentItem.event) ? "Register" : "Enter"}
              <ArrowForwardIcon style={{ fontSize: 18 }} />
            </button>
          </div>
        </div>

        <div className="d-flex flex-wrap px-3 px-md-4 py-2 justify-content-between mt-0 mt-md-5 ">
          <div className="event-low-part d-flex py-md-0 py-2">
            <div className="">{"Name of the publisher"}</div>
            <div className="mx-2">|</div>
            <div className="">Published on {moment(item.createdAt).format("MMM DD HH:mm")}</div>
            {item.eventContentItem.event.address ? (
              <>
                <div className="mx-2">|</div>
                <div className="">{item.eventContentItem.event.address.city}</div>
              </>
            ) : null}
          </div>
          <div className="event-low-part d-flex ">
            <div className="">{item.eventContentItem.event?.users?.length} of your community friends are coming</div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
